<template>
  <div class="propertyTemplate">
    <el-card>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>商品属性</el-breadcrumb-item>
        <el-breadcrumb-item>属性管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <main class="content">
      <el-card>
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="属性名称">
            <el-input v-model="searchForm.name" placeholder="属性名称" size="mini" clearable></el-input>
          </el-form-item>
          <el-form-item label="属性描述">
            <el-input v-model="searchForm.description" placeholder="属性描述" size="mini" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch" size="mini">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table stripe :data="tableData" v-loading="loading" style="width: 100%">
          <el-table-column prop="name" label="名称" width="300"></el-table-column>
          <el-table-column prop="unit" label="单位" width="50"></el-table-column>
          <el-table-column prop="description" label="描述"></el-table-column>
          <el-table-column prop="type" label="类型" width="100">
            <template slot-scope="scope">
              <el-tag type="primary" disable-transitions>{{scope.row.type === 0 ? "字符串" : "数字" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="struct" label="结构" width="100">
            <template slot-scope="scope">
              <el-tag type="primary" disable-transitions>{{scope.row.struct === 0 ? "单值" : "列表" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="350" align="right">
            <template slot="header">
              <el-button type="primary" size="mini" @click="handleCreate">添加</el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text"
                size="mini"
                :disabled="scope.row.struct !== 1"
                @click="handleEditValue(scope.$index, scope.row)"
              >编辑值列表</el-button>
              <el-divider direction="vertical" ></el-divider>
              <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑信息</el-button>
              <el-divider direction="vertical" ></el-divider>
              <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;padding-top: 20px">
          <el-pagination
            background
            layout="sizes,prev, pager, next"
            :page-sizes="[10, 20, 50, 100]"
            v-if="total>0"
            :total="total"
            :page-size="pageSize"
            @size-change="handleSizeChange"
            @current-change="onPageChange"
            @prev-click="onPageChange"
            @next-click="onPageChange"
          ></el-pagination>
        </div>
      </el-card>
    </main>
    <el-dialog
      title="属性模板"
      :visible.sync="editDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="单位">
          <el-input v-model="editForm.unit" placeholder="请输入单位" clearable></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="editForm.description" placeholder="请输入描述" clearable></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="editForm.type" placeholder="请选择属性类型" clearable>
            <el-option label="字符串" value="0"></el-option>
            <el-option label="数字" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结构" prop="struct">
          <el-select v-model="editForm.struct" placeholder="请选择属性结构" clearable>
            <el-option label="单值" value="0"></el-option>
            <el-option label="列表" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        name: "",
        description: ""
      },
      statusOptions: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "0",
          label: "无效"
        },
        {
          value: "1",
          label: "有效"
        }
      ],
      loading: false,
      total: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      editDialogVisible: false,
      editForm: {
        id: "",
        name: "",
        unit: "",
        description: "",
        type: "",
        struct: ""
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
        struct: [
          { required: true, message: '请选择结构', trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
    onSearch() {
      this.loading = true;
      let _this = this;
      let params = {};
      if (this.searchForm.name != "") {
        params["name"] = this.searchForm.name;
      }
      if (this.searchForm.description != "") {
        params["description"] = this.searchForm.description;
      }
      this.$axios
        .post("/admin/property/search", {
          cond: params,
          page: this.currentPage - 1,size:this.pageSize
        })
        .then(function(response) {
          let resp = response.data;
          if (resp.header.status == 0) {
            _this.loading = false;
            _this.tableData = resp.data.content;
            _this.total = resp.data.totalElements;
          }
        })
        .catch(function(error) {});
    },
    handleCreate() {
      this.editForm.id = "";
      this.editForm.name = "";
      this.editForm.unit = "";
      this.editForm.description = "";
      this.editForm.type = "";
      this.editForm.struct = "";
      this.editDialogVisible = true;
    },
    handleEditValue(index, row) {
      this.$router.push({
        name: "propertyValue",
        params: { propertyId: row.id, unit: row.unit }
      });
    },
    onSubmit() {
      let that = this;
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$axios
            .post("/admin/property", this.editForm)
            .then(function(response) {
              let resp = response.data;
              if (resp.header.status == 0) {
                that.$notify({
                  title: "成功",
                  message: "数据保存成功",
                  type: "success"
                });
                that.editDialogVisible = false;
                that.onSearch();
              } else {
                that.$notify.error({
                  title: "错误",
                  message: resp.header.msg
                });
              }
            });
          }
      });
    },
    handleSizeChange(pageSize){
      this.pageSize = pageSize;
      this.onSearch();
    },
    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.onSearch();
    },
    handleEdit(index, row) {
      this.editForm.id = row.id;
      this.editForm.name = row.name;
      this.editForm.unit = row.unit;
      this.editForm.description = row.description;
      this.editForm.type = row.type + "";
      this.editForm.struct = row.struct + "";
      this.editDialogVisible = true;
    },
    handleDelete(index, row) {
      let _this = this;
      this.$confirm("是否删除属性模板【" + row.name + "】？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
        _this.$axios
          .delete("/admin/property/delete/" + row.id)
          .then(function(response) {
            let resp = response.data;
            if (resp.header.status === 0) {
              _this.$notify({
                title: "成功",
                message: "数据删除成功",
                type: "success"
              });
              _this.onSearch();
            } else {
              _this.$notify.error({
                title: "错误",
                message: resp.header.msg
              });
            }
          });
      });
    },
    handleClose() {}
  },
  created() {
    this.onSearch();
  }
};
</script>
<style>
</style>